import { Moon, Sun } from "@phosphor-icons/react";
import { useTheme } from "../hooks/useTheme.js";

export function ThemeToggle() {
	const { theme, toggle } = useTheme();
	const Icon = theme === "light" ? Moon : Sun;

	return (
		<button
			type="button"
			onClick={toggle}
			aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
			className="rounded-xl p-1.5 text-text-muted transition-colors duration-100 hover:bg-accent-bg hover:text-text-primary"
		>
			<Icon size={16} />
		</button>
	);
}
